var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('button',{on:{"click":_vm.submit}},[_vm._v("Pay now!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }